(function () {
  var timers = new Map();

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function clearTimer(sectionId) {
    if (timers.has(sectionId)) {
      window.clearInterval(timers.get(sectionId));
      timers.delete(sectionId);
    }
  }

  function setValues(countdown, days, hours, minutes, seconds) {
    var values = {
      days: days,
      hours: hours,
      minutes: minutes,
      seconds: seconds,
    };

    Object.keys(values).forEach(function (key) {
      var element = countdown.querySelector('[data-mm-countdown-value="' + key + '"]');

      if (element) {
        element.textContent = pad(values[key]);
      }
    });

    countdown.setAttribute(
      "aria-label",
      days + " days, " + hours + " hours, " + minutes + " minutes, and " + seconds + " seconds until launch"
    );
  }

  function updateCountdown(countdown, targetTime) {
    var remaining = Math.max(0, targetTime - Date.now());
    var totalSeconds = Math.floor(remaining / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    setValues(countdown, days, hours, minutes, seconds);
  }

  function initCountdown(section) {
    var sectionId = section.getAttribute("data-section-id");
    var countdown = section.querySelector("[data-mm-countdown]");

    if (!sectionId || !countdown) {
      return;
    }

    clearTimer(sectionId);

    var target = countdown.getAttribute("data-countdown-target");
    var targetTime = target ? Date.parse(target) : NaN;

    if (!Number.isFinite(targetTime)) {
      setValues(countdown, 0, 0, 0, 0);
      return;
    }

    updateCountdown(countdown, targetTime);

    timers.set(
      sectionId,
      window.setInterval(function () {
        updateCountdown(countdown, targetTime);
      }, 1000)
    );
  }

  function initForms(section) {
    var forms = section.querySelectorAll("form");

    forms.forEach(function (form) {
      if (form.dataset.mmSubmitInitialized === "true") {
        return;
      }

      form.dataset.mmSubmitInitialized = "true";

      form.addEventListener("submit", function () {
        var button = form.querySelector("[data-mm-submit-button]");

        if (!button) {
          return;
        }

        button.disabled = true;
        button.classList.add("mm-password-page__button--loading");
        button.setAttribute("aria-busy", "true");
      });
    });
  }

  function initSection(section) {
    if (!section) {
      return;
    }

    initCountdown(section);
    initForms(section);
  }

  function initAll(container) {
    var scope = container || document;
    var sections = scope.querySelectorAll("[data-mm-password-page]");

    sections.forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAll(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var section = event.target.querySelector("[data-mm-password-page]");

    if (section) {
      clearTimer(section.getAttribute("data-section-id"));
    }
  });
})();
